import { TableColumn, TableConfig } from "../../@shared/models/table.models";

export const PROJECT_DOCUMENT_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "name",
        header: "Document Name",
        type: "custom",
        template: "documentNameTemplate",
        width: "20%"
    },
    {
        field: "linkedDocType",
        header: "Document Type",
        type: "custom",
        template: "documentTypeTemplate",
        width: "12%"
    },
    {
        field: "assignees",
        header: "Shared with",
        type: "custom",
        template: "assigneesTemplate",
        width: "10%"
    },
    {
        field: "updatedAt",
        header: "Last Edited",
        type: "custom",
        template: "dateUpdatedTemplate",
        width: "13%"
    },
    {
        field: "dueDate",
        header: "Due Date",
        type: "custom",
        template: "dueDateTemplate",
        width: "10%"
    },
    {
        field: "status",
        header: "Status",
        type: "custom",
        template: "statusTemplate",
        width: "10%"
    },
    {
        field: "upcomingMilestone",
        header: "Upcoming Milestone",
        type: "custom",
        template: "upcomingMilestoneTemplate",
        width: "17%"
    },
    {
        field: "actions",
        header: "Actions",
        type: "custom",
        template: "actionsTemplate",
        width: "8%"
    }
];

export const PROJECT_DOCUMENT_TABLE_CONFIG: TableConfig = {
    selectable: true,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [5, 10, 20, 50],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No Documents Found",
    globalFilter: false,
    responsive: true
};
